export default [
  {
    path: '/:type/advice/list/',
    name: 'AdviceList',
    component: () => import('@/pages/advice/list')
  },
  {
    path: '/other/advice/add',
    name: 'AdviceAddOther',
    component: () => import('@/pages/advice/addOther')
  },
  {
    path: '/:type/advice/add',
    name: 'AdviceAdd',
    component: () => import('@/pages/advice/add')
  },
  {
    path: '/:type/advice/proportion/:id',
    name: 'AdviceProportion',
    component: () => import('@/pages/advice/proportion')
  },
  {
    path: '/:type/advice/view/:id',
    name: 'AdviceView',
    component: () => import('@/pages/advice/view')
  },
  {
    path: '/:type/advice/confirmer/:id',
    name: 'AdviceConfirmer',
    component: () => import('@/pages/advice/confirmer')
  }
]



// WEBPACK FOOTER //
// ./src/router/advice/index.js